<template>
  <div class="progress-content">
    <div :class="progressClasses"></div>
    <div :style="progressBarStyles" :class="progressBarClasses"></div>
  </div>
</template>

<script>
export default {
  name: 'Progressbar',
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    bgColorProgress: {
      type: String,
    },
    bgColorProgressBar: {
      type: String,
    },
  },
  data() {
    return {
      max: 100,
    };
  },
  computed: {
    computedValue() {
      return this.value ? parseFloat(this.value) : 0;
    },
    computedMax() {
      return parseFloat(this.max);
    },
    progressBarStyles() {
      return {
        width: 100 * (this.computedValue / this.computedMax) + '%',
      };
    },
    progressClasses() {
      let progressClass = {
        progress: true,
      };

      progressClass[`bg-${this.bgColorProgress}`] = !!this.bgColorProgress;

      return {
        ...progressClass,
      };
    },
    progressBarClasses() {
      let progressBarClass = {
        'progress-bar': true,
      };

      progressBarClass[`bg-${this.bgColorProgressBar}`] =
        !!this.bgColorProgressBar;

      return {
        ...progressBarClass,
      };
    },
  },
  mounted() {
    this.$el.querySelector('.progress-bar').setAttribute('role', 'progressbar');
    this.$el.querySelector('.progress-bar').setAttribute('aria-valuemin', '0');
    this.$el
      .querySelector('.progress-bar')
      .setAttribute('aria-valuemax', this.computedMax.toString());
    this.$el
      .querySelector('.progress-bar')
      .setAttribute('aria-valuenow', this.computedValue.toString());
  },
};
</script>

<style lang="stylus" scoped>
@import "../Styles/main.styl";
</style>
